export enum FileCutoffTimes {
  OFFICE = 'FILE_CUTOFF_PROFILE-OFFICE',
  DEPARTMENT = 'FILE_CUTOFF_PROFILE-DEPARTMENT',
  REC_STATUS = 'FILE_CUTOFF_PROFILE-REC_STATUS',
  PROFILE_CHANGE_STATUS = 'FILE_CUTOFF_PROFILE-PROFILE_CHANGE_STATUS',
  EFFECTIVE_DATE = 'EFFECTIVE_DATE',
  CUTOFF_NAME = 'FILE_CUTOFF_PROFILE-CUTOFF_NAME',
  DESCRIPTION = 'FILE_CUTOFF_PROFILE-DESCRIPTION',
  CUTOFF_TYPE = 'FILE_CUTOFF_PROFILE-CUTOFF_TYPE',
  DEFAULT_IND = 'FILE_CUTOFF_PROFILE-DEFAULT_IND',
  V_EXCEPTION_DATE = 'FILE_CUTOFF_PROFILE-V_EXCEPTION_DATE',
  EXP_FROM_DATE = 'FILE_CUTOFF_PROFILE-EXP_FROM_DATE',
  EXP_TO_DATE = 'FILE_CUTOFF_PROFILE-EXP_TO_DATE',
  FINAL_CUTOFF = 'FILE_CUTOFF_PROFILE-FINAL_CUTOFF',
  TIME_ZONE = 'FILE_CUTOFF_PROFILE-TIME_ZONE',
  TIME_STAMP = 'TIME_STAMP',
  UID = 'VIRTUAL-UID',
  PROFILE_UPDATE_PK = 'PROFILE_UPDATE_PK',
  PU_TIME_STAMP = 'PU_TIME_STAMP',
  NOTE = 'NOTE'
};
